/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Delete_Confirm_MsgInputs */



/**
* | output |
* | --- |
* | "This will permanently remove this deck." |
*
* @param {Decks_Delete_Confirm_MsgInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_delete_confirm_msg = /** @type {((inputs?: Decks_Delete_Confirm_MsgInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Delete_Confirm_MsgInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce deck sera définitivement supprimé.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este deck se eliminará de forma permanente.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este deck será removido permanentemente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo deck verrà rimosso definitivamente.")
	return /** @type {LocalizedString} */ ("This will permanently remove this deck.")
});